declare namespace $ {

	type $easyreels_user_signin__start_easyreels_user_1 = $mol_type_enforce<
		ReturnType< $easyreels_user['sign_in'] >
		,
		ReturnType< $easyreels_user_signin['start'] >
	>
	type $mol_link__arg_easyreels_user_2 = $mol_type_enforce<
		({ 
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__hint_easyreels_user_3 = $mol_type_enforce<
		ReturnType< $easyreels_user['library_title'] >
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__sub_easyreels_user_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $easyreels_user_notify__uri_easyreels_user_5 = $mol_type_enforce<
		ReturnType< $easyreels_user['bot_uri'] >
		,
		ReturnType< $easyreels_user_notify['uri'] >
	>
	type $mol_link__arg_easyreels_user_6 = $mol_type_enforce<
		({ 
			'page': string,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_easyreels_user_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_button_minor__title_easyreels_user_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_easyreels_user_9 = $mol_type_enforce<
		ReturnType< $easyreels_user['sign_out'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $easyreels_user_quota__used_bytes_easyreels_user_10 = $mol_type_enforce<
		ReturnType< $easyreels_user['used_bytes'] >
		,
		ReturnType< $easyreels_user_quota['used_bytes'] >
	>
	type $easyreels_user_quota__limit_bytes_easyreels_user_11 = $mol_type_enforce<
		ReturnType< $easyreels_user['limit_bytes'] >
		,
		ReturnType< $easyreels_user_quota['limit_bytes'] >
	>
	type $easyreels_user_notify__uri_easyreels_user_12 = $mol_type_enforce<
		ReturnType< $easyreels_user['bot_uri'] >
		,
		ReturnType< $easyreels_user_notify['uri'] >
	>
	type $mol_page__title_easyreels_user_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_easyreels_user_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_easyreels_user_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $easyreels_user_recorder__tools_easyreels_user_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $easyreels_user_recorder['tools'] >
	>
	type $easyreels_user_recorder__links_easyreels_user_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $easyreels_user_recorder['links'] >
	>
	type $mol_page__title_easyreels_user_18 = $mol_type_enforce<
		ReturnType< $easyreels_user['library_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__head_easyreels_user_19 = $mol_type_enforce<
		ReturnType< $easyreels_user['library_head'] >
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__tools_easyreels_user_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_easyreels_user_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_link__arg_easyreels_user_22 = $mol_type_enforce<
		({ 
			'page': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__hint_easyreels_user_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link['hint'] >
	>
	type $mol_link__sub_easyreels_user_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $easyreels_user extends $mol_view {
		Theme( ): $mol_theme_auto
		page( ): string
		content( ): readonly(any)[]
		Guest_lang( ): $easyreels_i18n_switch
		sign_in( next?: any ): any
		Signin( ): $easyreels_user_signin
		library_title( ): string
		Library_icon( ): $mol_icon_filmstrip
		Library_link( ): $mol_link
		bot_uri( ): string
		Sheet_notify( ): $easyreels_user_notify
		Library_open( ): $mol_link
		library_head( ): readonly(any)[]
		Lang( ): $easyreels_i18n_switch
		sign_out( next?: any ): any
		Sign_out( ): $mol_button_minor
		used_bytes( ): number
		limit_bytes( ): number
		Quota( ): $easyreels_user_quota
		Library_notify( ): $easyreels_user_notify
		Upload( ): $easyreels_user_upload
		Recordings( ): $easyreels_user_recordings
		Camera_icon( ): $mol_icon_camera
		plugins( ): readonly(any)[]
		attr( ): ({ 
			'easyreels_user_page': ReturnType< $easyreels_user['page'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): ReturnType< $easyreels_user['content'] >
		Placeholder( ): $mol_view
		Guest( ): $mol_page
		Recorder( ): $easyreels_user_recorder
		Library( ): $mol_page
		Camera_link( ): $mol_link
	}
	
}

//# sourceMappingURL=user.view.tree.d.ts.map